<template>
    <div class="w-full m-3">
        <div class="inline-block pr-3 label-width align-top" :class="{'shake': !!error}">
            <span class="text-error-700"
                  v-if="required">*</span>
            <slot name="text"><span>{{ colonText }}</span></slot>
        </div>
        <div class="inline-block input-width align-top">
            <slot></slot>
        </div>
        <div class="inline-block align-middle text-error-500" v-if="showError">{{ pretty }}</div>
    </div>
</template>
<script>
export default {
    props: {
        text: String,
        error: [String, Boolean],
        showError: {
            type: Boolean,
            default: true
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        pretty() {
            if (this.error) {
                return ' * ' + this.error
            }
            return ''
        },
        colonText() {
            if (typeof (this.text) != 'string') {
                return this.text
            }
            if (this.text.length == 0) {
                return ''
            }
            var last = this.text.charAt(this.text.length - 1)
            if (['!', '?'].indexOf(last) == -1) {
                return this.text + ':'
            }
            return this.text
        }
    }
}
</script>
<style lang="scss" scoped>
.label-width {
    width: 180px;
}

.input-width {
    width: 240px
}

.shake {
    animation-name: shake;
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: shake;
}

@keyframes shake {
    from,
    to {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }

    10%,
    30%,
    50%,
    70%,
    90% {
        -webkit-transform: translate3d(-10px, 0, 0);
        transform: translate3d(-10px, 0, 0);
    }

    20%,
    40%,
    60%,
    80% {
        -webkit-transform: translate3d(10px, 0, 0);
        transform: translate3d(10px, 0, 0);
    }
}

</style>


